import React from "react";
import { Row, Column, FormGroup, Checkbox } from "carbon-components-react";
import useGet from "../../hooks/useGet";
import DynamicCheckbox from "../Checkboxes/DynamicCheckbox";
import {
  isCandidatureOptionChecked,
  updateCheckedOptions,
} from "../../services/Utils";
import { useEffect } from "react";

const BusinessPhaseForm = ({
  disabled,
  candidature,
  selectedBusinessPhases,
  setSelectedBusinessPhases,
}) => {
  const { data: businessPhases } = useGet("/lookup/business-phases");

  const updatePhases = (id, checked) => {
    setSelectedBusinessPhases(
      updateCheckedOptions(selectedBusinessPhases, id, checked)
    );
  };

  useEffect(() => {}, [selectedBusinessPhases]);

  return (
    <FormGroup legendText="FASE DO NEGÓCIO?" className="section-header">
      {selectedBusinessPhases && (
        <fieldset className="bx--fieldset">
          <legend className="bx--label">
            15. Em que fase está o teu negócio?
          </legend>
          <p>
            Escolhe as opções que melhor descrevem o ponto em que está a tua
            ideia de negócio, projecto, marca ou empresa:
          </p>
          <Row>
            <Column sm={12} md={12} lg={12}>
              {businessPhases.map((x) => (
                <DynamicCheckbox
                  key={"bp" + x.id}
                  id={x.id}
                  disabled={disabled}
                  label={x.description}
                  updateItems={updatePhases}
                  checked={isCandidatureOptionChecked(
                    selectedBusinessPhases,
                    x.id
                  )}
                />
              ))}
            </Column>
          </Row>
        </fieldset>
      )}
    </FormGroup>
  );
};

BusinessPhaseForm.defaultProps = {
  disabled: false,
};

export default BusinessPhaseForm;
